import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Image from "next/image";
import Logo from "public/assets/icons/logo.png";
import { Backdrop } from "@mui/material";

interface LoadBackdropProps {
  isLoading: boolean;
}

const LoadBackdrop: React.FC<LoadBackdropProps> = ({ isLoading }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <CircularProgress size={80} />
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "30%",
            transform: "translateX(-50%)",
          }}
        >
          <Image alt="Лого" width="45px" height="38px" src={Logo} />
        </Box>
      </Box>
    </Backdrop>
  );
};

export default LoadBackdrop;
